<template>
    <header class="header-area">
        <div id="header-sticky" :class="(isscrolled)?'menu-area sticky-menu':'menu-area'">
            <div class="container">
                <div class="second-menu">
                    <div class="row align-items-center">
                        <div class="col-xl-2 col-lg-3 col-md-12 flexMobile">
                            <div class="responsive" id="menutoggle" @click="menutoggle">
                                <i class="fas fa-solid fa-bars"></i>
                            </div>
                            <div class="logo">
                                <router-link :to="{ name: 'HomePage'}">
                                    <img :src="companyLogo" alt="logo">
                                </router-link>
                            </div>
                            <button class="btn toggle-button-right" @click="OpenRightToggle">
                                <i class="houzez-icon icon-single-neutral-circle ml-1"></i>
                            </button>
                        </div>

                        <div class="col-xl-10 col-lg-9 col-md-3" v-if="!isUserLoggedIn">
                            <div class="main-nav navbar slideout-menu slideout-menu-right " id="nav-mobile1" :class="isText && 'open'">
                                <ul id="mobile-main-nav" class="navbar-nav mobile-navbar-nav">
                                    <li class="login-link" @click="OpenRightToggle">
                                        <router-link :to="{name:'Login'}">
                                            <i class="fas fa-sign-in-alt"></i> {{$t('StoreFront.Login')}}
                                        </router-link>
                                    </li>
                                    <li @click="OpenRightToggle">
                                        <router-link :to="{name:'SignupPage'}" @click="OpenRightMenu" class="top-btn">
                                            <i class="fas fa-user-circle"></i> {{$t('StoreFront.Sign Up')}}
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                            <div id="menu" class="main-menu text-right" :class="isTextRed && 'active-nav'">
                                <nav id="mobile-menu">
                                    <ul>
                                        <li v-for="link in NavLinks">
                                            <router-link class="nav-link" v-if="link.routeUrl!='Booking'" :to="{ name: link.routeUrl,params:link.params}" @click="menutoggle">
                                                {{link.displayText}}
                                            </router-link>
                                            <router-link class="nav-link" v-if="link.routeUrl=='Booking'" :to="{ name: 'Restaurant Detail', params: { Id: '11319CEB-3883-40EF-9FD9-C92A89B7DAC3' } }" @click="menutoggle">
                                                {{link.displayText}}
                                            </router-link>

                                        </li>
                                        <li class="login-link show-only-on-desktop"> <router-link :to="{name:'Login'}">{{$t('StoreFront.Login')}}</router-link></li>
                                        <li class="show-only-on-desktop">
                                            <router-link :to="{name:'SignupPage'}" @click="OpenRightMenu" class="">
                                                <i class="fas fa-user-circle"></i> {{$t('StoreFront.Sign Up')}}
                                            </router-link>
                                        </li>

                                        <!--<li>
                                            <Dropdown :disabled="disable" v-model="LanguageId"
                                                      :options="LanguageList"
                                                      optionValue="value"
                                                      class="language-dropdown"
                                                      optionLabel="text"
                                                      @change="ChangeLanguage">

                                            </Dropdown>
                                        </li>-->
                                        <li id="language-dropdown-box" class="nav-item dropdown pr-link show show-only-on-desktop">
                                            <span>{{currentSelectLang}} </span>
                                            <ul class="dropdown-menu show">
                                                <li class="login-link" v-for=" lang in LanguageList" @click="ChangeLanguage(lang)">{{lang.text}}</li>
                                            </ul>
                                        </li>
                                    </ul>

                                </nav>
                            </div>
                        </div>

                        <div class="col-xl-10 col-lg-9 col-md-2" v-if="isUserLoggedIn">


                            <div class="main-nav navbar slideout-menu slideout-menu-right " id="nav-mobile1" :class="isText && 'open'">
                                <ul id="mobile-main-nav" class="navbar-nav mobile-navbar-nav">
                                    <li>
                                        <a class="nav-link" href="javascript:;" @click="goToPortalDashboard">
                                            <i class="fas fa-tachometer-alt"></i>
                                            <span>
                                                <!--Go To Portal-->{{$t('StoreFront.GoToPortal')}}
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="nav-link" routerlinkactive="active" @click="this.$emit('logout')" ng-reflect-router-link-active="active">
                                            <i class="fa fa-sign-out-alt"></i>
                                            <span><!--Logout-->{{$t('StoreFront.Logout')}}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div id="menu" class="main-menu text-right" :class="isTextRed && 'active-nav'">
                                <nav id="mobile-menu">
                                    <ul>
                                        <li v-for="(link, index) in NavLinks" class="dropdown" :key="index">
                                            <router-link :class="[JSON.parse(link.childMenu).length >0 ? 'dropdown-toggle' : '','nav-link']" v-if="link.routeUrl!='Booking'" :to="{ name: link.routeUrl,params:link.params}" @click="menutoggle">{{link.displayText}}</router-link>
                                            <router-link :class="[JSON.parse(link.childMenu).length >0 ? 'dropdown-toggle' : '','nav-link']" v-if="link.routeUrl=='Booking'" :to="{ name: 'Restaurant Detail', params: { Id: '11319CEB-3883-40EF-9FD9-C92A89B7DAC3' } }" @click="menutoggle">{{link.displayText}}</router-link>

                                            <ul class="dropdown-menu" v-if="JSON.parse(link.childMenu).length > 0">
                                                <li v-for="childLink in JSON.parse(link.childMenu)">
                                                    <router-link class="nav-link" :to="{path:childLink.routeUrl}">{{childLink.displayText}}</router-link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item dropdown pr-link show show-only-on-desktop">
                                            <router class="nav-link dropdown-toggle" data-toggle="dropdown" href="#/dashboard" aria-expanded="true"><!--My Account-->{{$t('StoreFront.MyAccount')}}</router>
                                            <ul class="dropdown-menu show">
                                                <li>
                                                    <a class="nav-link" href="javascript:;" @click="goToPortalDashboard"><!--Go To Portal-->{{$t('StoreFront.GoToPortal')}}</a>
                                                </li>
                                                <li>
                                                    <a class="login-link" routerlinkactive="active" @click="this.$emit('logout')" ng-reflect-router-link-active="active"><!--Logout-->{{$t('StoreFront.Logout')}}</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <!--<li>
                                            <Dropdown :disabled="disable" v-model="LanguageId"
                                                      :options="LanguageList"
                                                      optionValue="value"
                                                      class="language-dropdown"
                                                      optionLabel="text"
                                                      @change="ChangeLanguage">
                                                
                                            </Dropdown>
                                        </li>-->
                                        <li id="language-dropdown-box" class="nav-item dropdown pr-link show">
                                            <span>{{currentSelectLang}}</span>
                                            <ul class="dropdown-menu show">
                                                <li class="login-link" v-for=" lang in LanguageList" @click="ChangeLanguage(lang)">{{lang.text}}</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </nav>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </header>

</template>

<script>
    import { ref } from 'vue'
    import service from '@/Services/frontEndService.js'
    export default {
        components: {

        },
        name: 'HeaderVue',
        props: ['NavLinks', 'isUserLoggedIn', 'name'],
        emits: ["openSignUpdmodel", "openLoginModel", "logout"],

        data() {
            const isTextRed = ref(false)
            const isText = ref(false)
            function menutoggle() {
                isTextRed.value = !isTextRed.value;
                document.getElementById("nav-mobile1").classList.remove("open");
                isText.value = false;
            }
            function OpenRightToggle() {
                isText.value = !isText.value;
                document.getElementById("menu").classList.remove("active-nav");
                isTextRed.value = false;
            }
            function CloseMenutoggle() {
                document.getElementById("nav-mobile1").classList.remove("open");
                isText.value = false;
                document.getElementById("menu").classList.remove("active-nav");
                isTextRed.value = false;
            }
            return {
                companyLogo: '',
                isscrolled: false,
                IsOpenRightMenu: false,
                isTextRed,
                isText,
                menutoggle,
                LanguageList: [],
                LanguageId: null,
                userId: localStorage.getItem("userId"),
                OpenRightToggle,
                CloseMenutoggle,
                currentSelectLang: ''
            }
        },
        created() {
            this.getCompanyLogo();
            this.getlanguageList();
            if (localStorage.getItem('Language') == 'en') {
                this.LanguageId = '364697eb-c5d6-44fa-8c08-ece45aed1844';
                this.currentSelectLang = "English"
            } else {
                this.LanguageId = 'cdf82d9b-07af-427e-9261-a3f45bc98f8f';
                this.currentSelectLang = "Spanish"
            }

            //if (this.$route.name !== 'HomePage') {
            //    debugger;
            //    var dataClass = document.body;
            //    dataClass.classList.add("innerPages");
            //}
            //if (this.$route.name === 'HomePage') {
            //    debugger;
            //    var dataClass = document.body;
            //    dataClass.classList.remove("innerPages");
            //}
        },

        mounted() {
            window.addEventListener('scroll', this.updateScroll);
            if (this.$route.name !== 'HomePage') {
                debugger;
                var dataClass = document.body;
                dataClass.classList.add("innerPages");
            }
            if (this.$route.name === 'HomePage') {
                debugger;
                var dataClass = document.body;
                dataClass.classList.remove("innerPages");
            }
        },
        watch: {
            '$route.name'(newRoute) {
                if (newRoute !== 'HomePage') {
                    document.body.classList.add("innerPages");
                } else {
                    document.body.classList.remove("innerPages");
                }
            }
        },
        methods: {
            ChangeLanguage(event) {
                this.currentSelectLang = event.text;
                var item = this.LanguageList.find(x => x.value == event.value);
                let model = {
                    userId: localStorage.getItem("userId"),
                    companyId: localStorage.getItem("companyId"),
                    SelectedLanguage: this.LanguageId
                }
                localStorage.removeItem("domain");
                localStorage.removeItem("Language");
                localStorage.removeItem("LanguageId");
                localStorage.setItem("Language", item.masterName);
                localStorage.setItem("languageId", item.value);
                this.$router.go(0);
                //UserService.UpdateLanguageId(model)
                //    .then(response => {
                //        //this.$toast.success("");
                //        localStorage.removeItem("Language");
                //        localStorage.setItem("Language", item.masterName);
                //        this.$router.go(0);
                //    });
                
            },
            getlanguageList() {
                if (this.userId == null || this.userId == undefined) {
                    this.userId = '00000000-0000-0000-0000-000000000000'
                }
                service.GetLanguageList('Language', 'Language', this.userId)
                    .then(response => {
                        this.LanguageList = response.data;



                    });
            },
            getCompanyLogo() {
                 let logoUrl = localStorage.getItem('companyLogo') == null ? localStorage.getItem('companySecondaryLogo') : localStorage.getItem('companyLogo');
                this.companyLogo = (this.$filters.IsNull(logoUrl, 'null') == 'null') ? require('../../../../../assets/images/logo/default-logo.png') : logoUrl;
            },
            OpenRightMenu() {
                this.IsOpenRightMenu = (this.IsOpenRightMenu) ? false : true;
                let navbar = document.getElementsByClassName("navbar-default");
                let pageBodyWrapper = document.getElementsByClassName("page-body-wrapper");
                let sectionFooter = document.getElementsByClassName("section-footer");
                let footerbottom = document.getElementById('footer-bottom');
                if (this.IsOpenRightMenu) {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.add("show-menu1");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.add("show-menu1");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.add("show-menu1");
                    }
                    // footerbottom.classList.add("show-menu1");
                } else {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.remove("show-menu1");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.remove("show-menu1");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.remove("show-menu1");
                    }
                    //  footerbottom.classList.remove("show-menu1");
                }

            }, ToggleLeftMenu(Action = null) {
                this.IsOpenLeftMenu = (this.IsOpenLeftMenu) ? false : true;
                let navbar = document.getElementsByClassName("navbar-default");
                let pageBodyWrapper = document.getElementsByClassName("page-body-wrapper");
                let sectionFooter = document.getElementsByClassName("section-footer");
                let footerbottom = document.getElementById('footer-bottom');
                if (this.IsOpenLeftMenu) {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.add("show-menu");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.add("show-menu");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.add("show-menu");
                    }
                    //footerbottom.classList.add("show-menu");
                } else {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.remove("show-menu");
                    }
                    //footerbottom.classList.remove("show-menu");
                }
            },
            CloseLeftMenu() {
                if (this.IsOpenLeftMenu) {
                    let navbar = document.getElementsByClassName("navbar-default");
                    let pageBodyWrapper = document.getElementsByClassName("page-body-wrapper");
                    let sectionFooter = document.getElementsByClassName("section-footer");

                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.remove("show-menu");
                    }
                    this.IsOpenLeftMenu = false

                }

            },
            updateScroll() {
                this.scrollPosition = window.scrollY;
                if (this.scrollPosition != 0) {
                    this.isscrolled = true;
                }
                else {
                    this.isscrolled = false;
                }

            },
            goToPortalDashboard() {
                this.$emit('goToPortal')
            },
            logoutfrommenu() {
                this.$emit('logout');
            },
            
        }
    }
</script>
